
import React from "react";

const EstimationNotes: React.FC = () => {
  return (
    <div className="mt-6 text-sm text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
      <p className="font-semibold">Notes:</p>
      <ul className="list-disc pl-5 mt-2 space-y-1">
        <li>Story points follow the Fibonacci sequence (1, 2, 3, 5, 8, 13, 21)</li>
        <li>Points vary by component type to account for different complexity levels</li>
        <li>Development effort is approximately 40% of the total estimate</li>
        <li>Testing effort is approximately 30% of the total estimate</li>
        <li>UAT effort is approximately 20% of the total estimate</li>
        <li>Project Management effort is approximately 10% of the total estimate</li>
        <li>Estimates include discovery, development, testing, and bug fixing</li>
        <li>This is a preliminary estimate for discussion purposes only</li>
      </ul>
    </div>
  );
};

export default EstimationNotes;
